import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { PassKeyService } from 'src/app/core/services/passkey-service';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { PasskeyotpViewComponent } from '../passkeyotp-view/passkeyotp-view.component';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';

interface ProductDescription {
  code: string;
  description: string;
}
@Component({
  selector: 'ms-m4passkey-generator',
  templateUrl: './m4passkey-generator.component.html',
  styleUrls: ['./m4passkey-generator.component.scss']
})

export class M4passkeyGeneratorComponent implements OnInit {
  public cmsObj: CmsObject[];
  public passKeyIntroduction: string;
  productsDescription: ProductDescription[] = [
    {code: 'MAGO4', description: 'Mago4'},
  ];
  constructor(
    private _formBuilder: FormBuilder,
    private passKeyService: PassKeyService,
    public dialog: MatDialog,
    public cmsService: CmsService,
    public workFlow: WorkFlowService,
  ) {}

  search = this._formBuilder.group({
    productCode: ''
  });

  async  ngOnInit(){
  await this.getCmsObj();
}
async getCmsObj() {
  //recupero le stringhe della pagina
  this.cmsObj = await this.cmsService.getCmsObj(this.workFlow.getLanguageForCms(), 'passKey');
  this.passKeyIntroduction = this.cmsObj.find((x) => x.ContentName == 'passKey.introduction').ContentTranslation;
}

  async generateOTPToken(){
    try{
      let otpTokenRes = await this.passKeyService.generateOtpToken(this.search.value['productCode'])
      if(!otpTokenRes.Result || !otpTokenRes.Content) throw new Error()
      this.dialog.open(PasskeyotpViewComponent, {
        data: otpTokenRes.Content
      });
    }
    catch(err){
      alert('Error during generating otp token')
    }
  }

  disableButton(): boolean {
    return (!this.search.value['productCode'])
  }
}
